/**
 * Filters pets by species if a filter is provided
 * @param {Array} pets - Array of pet objects
 * @param {string|null} specieFilter - Species to filter by (e.g., 'Cat', 'Dog')
 * @returns {Array} Filtered array of pets
 */
export const filterPetsBySpecie = ({ pets, specieFilter }) => {
  if (!specieFilter) {
    return pets;
  }

  const normalizedFilter = specieFilter.trim().toLowerCase();
  return pets.filter((pet) => (
    (pet.Specie?.trim().toLowerCase() || '') === normalizedFilter
  ));
};

/**
 * Converts pet objects to react-select option format
 * @param {Array} pets - Array of pet objects
 * @returns {Array} Array of react-select options
 */
export const convertPetsToOptions = (pets) => pets.map((pet) => ({
  label: pet.Name || '',
  pet,
  value: pet.Id || pet.id,
}));

/**
 * Custom filter function for react-select to search by pet name
 * @param {Object} option - react-select option object
 * @param {string} inputValue - The search input value
 * @returns {boolean} Whether the option matches the search
 */
export const filterPetByName = (option, inputValue) => {
  if (!inputValue) {
    return true;
  }
  const searchTerm = inputValue.toLowerCase();
  const petName = option.data.pet?.Name?.toLowerCase() || '';
  return petName.includes(searchTerm);
};
